import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "traffic__legend-list" }
const _hoisted_2 = { class: "traffic__legend-value" }
const _hoisted_3 = { class: "traffic__legend-item" }
const _hoisted_4 = { class: "traffic__legend-value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_translated_text_component = _resolveComponent("translated-text-component")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.trafficLegendItems, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item.speed,
          class: "traffic__legend-item"
        }, [
          _createElementVNode("div", {
            class: "traffic__legend-line",
            style: _normalizeStyle({'background-color': item.color})
          }, null, 4),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_translated_text_component, {
              translation: item.name
            }, null, 8, ["translation"])
          ])
        ]))
      }), 128)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "traffic__legend-line",
          style: _normalizeStyle({'background-color': _ctx.noDataColor})
        }, null, 4),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_translated_text_component, { translation: "traffic_no_data" })
        ])
      ])
    ])
  ]))
}